const STORAGE_KEY = "ordering-user";

export function getStoredPassengerUserId(): number | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const id = Number.parseInt(raw, 10);
    return Number.isNaN(id) ? null : id;
  } catch {
    return null;
  }
}

export function setStoredPassengerUserId(userId: number | null): void {
  if (userId == null) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }

  localStorage.setItem(STORAGE_KEY, String(userId));
}
